import { render } from "./serverLicenceForm.vue?vue&type=template&id=6f430ace&ts=true"
import script from "./serverLicenceForm.vue?vue&type=script&lang=ts"
export * from "./serverLicenceForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__